// Hide and show resolved annotations

class ResolvedAnnotationsHandler {
  constructor(params = {}) {
    N2.offHandle('change', '.js-show-resolved-annotations')
    this.params = params
    this.setListener()
    if (this.params.resolved) {
      this.setShowing();
    } else {
      this.setDefaultValue()
    }
  }

  clearOpenAnnotations() {
    if ($('.annotation-container.resolved.is-open').length) {
      // click the screen in case any annotations are open
      $('.js-annotation-boundry').click()
    }
  }

  toggleAnnotations(checked) {
    $('.annotation.approved').toggle(checked)
  }

  setDefaultValue() {
    if (localStorage.getItem('show_resolved_annos') == null){
      this.setShowing()
    } else {
      $('.js-show-resolved-annotations').prop('checked', localStorage.getItem('show_resolved_annos') === "true")
    }
    this.clearOpenAnnotations()
    this.toggleAnnotations(localStorage.getItem('show_resolved_annos') === "true")
  }

  setListener() {
    N2.handle('change', '.js-show-resolved-annotations', (e) => {
      let checked = $('.js-show-resolved-annotations').is(':checked')
      localStorage.setItem('show_resolved_annos', checked)
      this.clearOpenAnnotations()
      this.toggleAnnotations(checked)
    });
  }

  setShowing() {
    $('.js-show-resolved-annotations').prop('checked', true)
    localStorage.setItem('show_resolved_annos', "true")
  }
}

export default ResolvedAnnotationsHandler
